import { render, staticRenderFns } from "./IntelytAlert.vue?vue&type=template&id=bd1609b2&scoped=true&"
import script from "./IntelytAlert.vue?vue&type=script&lang=js&"
export * from "./IntelytAlert.vue?vue&type=script&lang=js&"
import style0 from "./IntelytAlert.vue?vue&type=style&index=0&id=bd1609b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1609b2",
  null
  
)

export default component.exports